@if (!(isLoading$ | async)) {
    <app-header></app-header>
}
@if (!(isLoading$ | async)) {
    <div>
        <router-outlet></router-outlet>
    </div>
}
@if (!(isLoading$ | async)) {
    <app-footer></app-footer>
}
@if (isLoading$ | async) {
    <app-spinner-loader [showOverlay]="true"></app-spinner-loader>
}
